module.exports = __webpack_public_path__ + "img/timer-stopwatch.1e707cfa.svg";